module.exports = __webpack_public_path__ + "static/media/ic_clear.3accdd1e.svg";